// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__w6Pjo","dark":"Icon_dark__yIpGK","icon-loading":"Icon_icon-loading__HuI-Y"};